import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import Chart from "react-apexcharts";
import { stateChart } from "../../../utils/stateChart";
import { Estudents } from "../../../utils/constants";

const initialState = stateChart([
  "INVESTIGADOR ESTUDIANTE REGULAR",
  "INVESTIGADOR PRACTICANTE",
  "INVESTIGADOR PASANTE",
  "INVESTIGADOR AYUDANTE DE INVESTIGACIÓN",
  "INVESTIGADOR TESISTA DE GRADO",
  "INVESTIGADOR TESISTA POSGRADO",
]);

const ReportByEstudents = ({ data }) => {
  const [state] = useState(initialState);

  const quantityUserByProjects = (num) => {
    let usersp, sex, cont;
    const res = data
      .filter((project) => project.users.length >= 1)
      .map((filteredPerson) => filteredPerson.users2);
    usersp = res.flat();
    sex = usersp.map((project) => project.pivot);
    cont = sex.filter((project) => project.staff_id === num);
    return cont.length;
  };

  return (
    <Grid item xs={8} sm={8} md={12}>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <Chart
          options={state.options}
          series={[
            quantityUserByProjects(14),
            quantityUserByProjects(15),
            quantityUserByProjects(16),
            quantityUserByProjects(17),
            quantityUserByProjects(18),
            quantityUserByProjects(19),
          ]}
          type="pie"
          height={380}
          className="chart"
        />
      </Paper>
    </Grid>
  );
};

/*const Estudents = [
  { id: 14, name: 'INVESTIGADOR ESTUDIANTE REGULAR' },
  { id: 15, name: 'INVESTIGADOR PRACTICANTE' },
  { id: 16, name: 'INVESTIGADOR PASANTE' },
  { id: 17, name: 'INVESTIGADOR AYUDANTE DE INVESTIGACIÓN' },
  { id: 18, name: 'INVESTIGADOR TESISTA DE GRADO' },
  { id: 19, name: 'INVESTIGADOR TESISTA POSGRADO' },
];*/

//SELECT * FROM `project` INNER JOIN project_has_users on project.id = project_has_users.project_id INNER JOIN staff on project_has_users.staff_id = staff.id WHERE year like 2022 ORDER BY `project_has_users`.`staff_id` ASC
//http://localhost/apispirit/public/api/projects/year/2022

export default ReportByEstudents;
